<template>
  <div
    :class="open ? 'translate-x-0' : 'translate-x-full'"
    class="prismic-default-headings prismic-rich-text-default fixed inset-0 z-[60] bg-white transition duration-200"
  >
    <div
      class="sticky top-0 flex h-14 items-center justify-start border-b bg-highlight text-white"
    >
      <span class="absolute left-1/2 flex -translate-x-1/2">
        <PrismicHeading v-if="slice.title" :field="slice.title" />
      </span>
      <button type="button" @click="open = false">
        <FontAwesomeIcon
          :icon="{ prefix: 'fas', iconName: 'chevron-left' }"
          class="container h-5 w-5 cursor-pointer"
          aria-hidden="true"
        />
      </button>
    </div>
    <div class="container mt-2 h-[calc(100vh-80px)] overflow-y-auto">
      <PrismicRichText v-if="slice.description" :field="slice.description" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import PrismicHeading from '@/components/Prismic/PrismicHeading.vue';

defineProps({
  slice: {
    type: Object,
    required: true,
  },
});

const open = defineModel('open', {
  type: Boolean,
  required: true,
});

watch(
  () => open.value,
  newValue => {
    if (newValue) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }
);
</script>
